// ../stores/warnning.js
import moment from 'moment';
import create from 'zustand';

const DEFAULT_COOLDOWN_SEC = 60; // 1분

const useWarnningStore = create((set, get) => ({
  show: true,

  // key: `${member_no}:${code}` -> last notified ISO time
  check: {},

  // popup events
  // { id, member_no, device_sn?, code, level, name, message?, occurredAt }
  popups: [],

  setShow: (show) => set((state) => ({ ...state, show })),

  /**
   * addPopup(payload)
   * payload:
   *  - member_no (required)
   *  - code (required)
   *  - level (required) 1|2|3
   *  - name (optional) '주의'|'경고'|'위험'
   *  - message (optional) 표시 문구
   *  - device_sn (optional)
   *  - cooldownSec (optional) default 60s
   */
  addPopup: (payload) => {
    const {
      member_no,
      device_sn,
      code,
      level,
      name,
      message,
      cooldownSec = DEFAULT_COOLDOWN_SEC,
    } = payload || {};

    if (!member_no || !code || !level) return;

    set((state) => {
      // 기존 UX 유지: show가 꺼져 있으면 팝업 자체를 쌓지 않음
      if (!state.show) return state;

      const key = `${member_no}:${code}`;
      const last = state.check[key];

      if (last && !moment().isAfter(moment(last).add(cooldownSec, 'seconds'))) {
        return state;
      }

      const now = moment();
      const nowIso = now.toISOString();

      // 동일 (member_no, code)는 최신 1개만 유지
      const filtered = state.popups.filter(
        (p) => !(p.member_no === member_no && p.code === code)
      );

      const popup = {
        id: `${member_no}:${code}:${now.valueOf()}`,
        member_no,
        device_sn,
        code,
        level,
        name,
        message,
        occurredAt: nowIso,
      };

      return {
        ...state,
        check: { ...state.check, [key]: nowIso },
        popups: [...filtered, popup],
      };
    });
  },

  /**
   * legacy 호환: 예전 addPopups(userId) 호출을 깨지 않게 유지
   */
  addPopups: (userId) => {
    const member_no = userId;
    if (!member_no) return;

    get().addPopup({
      member_no,
      code: 'LEVEL1_GENERIC',
      level: 1,
      name: '주의',
      message: '이상 생체신호를 확인했습니다.',
      cooldownSec: DEFAULT_COOLDOWN_SEC,
    });
  },

  removePopup: (id) => {
    set((state) => ({
      ...state,
      popups: state.popups.filter((p) => p.id !== id),
    }));
  },

  clearPopups: () => set((state) => ({ ...state, popups: [] })),

  clearAll: () => set((state) => ({ ...state, popups: [], check: {} })),
}));

export default useWarnningStore;
